import { ChangeDetectorRef,Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { SurveyService } from '../service/survey.service';
import { ClientListInfoService } from 'src/app/_metronic/layout/core/client-list-info.service';


@Component({
  selector: 'app-callbackurl',
  templateUrl: './callbackurl.component.html',
  styleUrls: ['./callbackurl.component.scss']
})
export class CallbackurlComponent implements OnInit {
  private readonly notifier: NotifierService;
  public isDataAvailabe:number
  public complete_url:string
  public terminate_url:string
  public error_url:string
  public over_quota_url:string;
  public defaultAllLogin:boolean = false;
  public callBackComponentShow:boolean = false;
  constructor(
    private fb: FormBuilder,
    public surveyService: SurveyService,
    public notifierService: NotifierService,
    public clientService:ClientListInfoService,
    private cd :ChangeDetectorRef
  ) { 
    this.notifier = notifierService;
  }
  callback_form: FormGroup;
  ngOnInit(): void {
    this.initForm()
    this.getUrlDetails();
  }
  getUrlDetails(){
    this.surveyService.getCallbackUrl(this.clientService.loginClientDetails.uuid)
    .subscribe({
      next : (v:any) =>{
        console.log("next is ====>",v)
        this.isDataAvailabe = v.status;
        console.log(v.status == 1);
        if(v.status == 1){
          this.callBackComponentShow = true;
          this.defaultAllLogin = false;
          // this.complete_url = v.data.complete;
          // this.terminate_url = v.data.terminate;
          // this.error_url = v.data.failure;
          // this.over_quota_url = v.data.over_quota;
          this.callback_form.patchValue({  
            complete: v.data.complete,  
            terminate: v.data.terminate,  
            failure:v.data.failure,
            over_quota:v.data.over_quota 
          });
          this.cd.detectChanges();
        }
        else if(v.status == 2){
          this.callBackComponentShow = false;
          this.defaultAllLogin = true;
          this.cd.detectChanges();
        }
        else
        {
          this.callBackComponentShow = true;
          this.defaultAllLogin = false;
          this.cd.detectChanges();
        }
      },
      error: (e) =>{
        // console.log("error is ====>",e)
      },
      complete: () => {
        // console.info('complete')
      } 
    });

  }
  submit(){
    if(this.isDataAvailabe == 1){
      this.surveyService.updateCallback(this.callback_form.value.complete,this.callback_form.value.over_quota,this.callback_form.value.terminate,this.callback_form.value.failure)
      .subscribe({
        next : (v:any) =>{
          // console.log("next is ====>",v)
          if(v.status){
            this.notifier.notify('success', 'Successfully Saved');
          }else{
            this.notifier.notify('error', 'Something Went Wrong');
          }
        },
        error: (e) =>{
          console.log("error is ====>",e)
          this.notifier.notify('error', 'Something Went Wrong');
        },
        complete: () => {
          // console.info('complete')
        } 
      });
    }else{
      this.surveyService.submitCallback(this.callback_form.value.complete,this.callback_form.value.over_quota,this.callback_form.value.terminate,this.callback_form.value.failure)
      .subscribe({
        next : (v:any) =>{
          // console.log("next is ====>",v)
          if(v.status){
            this.notifier.notify('success', 'Successfully Saved');
          }else{
            this.notifier.notify('error', 'Something Went Wrong');
          }
        },
        error: (e) =>{
          console.log("error is ====>",e)
          this.notifier.notify('error', 'Something Went Wrong');
        },
        complete: () => {
          // console.info('complete')
        } 
      });
    }
  }
  initForm(){
    this.callback_form = this.fb.group({
      complete:[
        '',
        Validators.compose([
          Validators.required
        ])
      ],
      over_quota:[
        '',
        Validators.compose([
          Validators.required
        ])
      ],
      terminate:[
        '',
        Validators.compose([
          Validators.required
        ])
      ],
      failure:[
        '',
        Validators.compose([
          Validators.required
        ])
      ],

    })
  }
  
}
